module.exports = __webpack_public_path__ + "static/media/medication_black_24dp.a8cf00c4.svg";